import __request__ from "routing/request";
export function requestGet(path, hostname, requestOptions) {
  return __request__("GET", `/datanodes/${hostname}/rest/${path}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function requestPut(path, hostname, requestOptions) {
  return __request__("PUT", `/datanodes/${hostname}/rest/${path}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function requestPost(path, hostname, requestOptions) {
  return __request__("POST", `/datanodes/${hostname}/rest/${path}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function requestDelete(path, hostname, requestOptions) {
  return __request__("DELETE", `/datanodes/${hostname}/rest/${path}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
